import styled from 'styled-components';

import { TileContainer } from '../../../styles/containers.sc';

export const ListItem = styled(TileContainer)`
  font-size: 1.3rem;
  font-weight: 400;
  letter-spacing: 0.3px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a6};
  align-items: center;
  cursor: pointer;
  margin-top: 1rem;
`;

export const SpinnerContainer = styled.div`
  justify-self: center;
  padding: 2rem;
  background-color: ${({ theme }) => theme.white.a10};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

export const FormContainer = styled.div`
  border-top: 1px solid ${({ theme }) => theme.black.a1};
`;
